import { AspectRatio } from "@/components/ui/aspect-ratio";

interface Feature {
  title: string;
  description: string;
  gif: string;
}

interface PlatformFeaturesProps {
  title: string;
  features: Feature[];
}

export const PlatformFeatures = ({
  title,
  features,
}: PlatformFeaturesProps) => {
  return (
    <div className="mt-12">
      <h3 className="text-lg font-semibold mb-6">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="bg-accent p-6 rounded-lg space-y-3"
          >
            <AspectRatio
              ratio={1 / 1}
              className="bg-muted rounded-md overflow-hidden"
            >
              <img
                src={feature.gif}
                alt={feature.title}
                className="object-cover w-full h-full"
              />
            </AspectRatio>
            <h4 className="font-semibold">{feature.title}</h4>
            <p className="text-muted-foreground text-sm">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
